import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import appConfig from '@/modules/apps/config'

import AppBase from './app-base'
import { ButtonIconSquare } from '@/modules/base/components/buttons'
import { useNavigate } from 'react-router'

const OwnCard = ({
  className,
  href,
  name,
  icon,
  developerId,
  version,
  status,
  appOpenUrl,
}) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const onClick = e => {
    e.stopPropagation()
    e.preventDefault()
    navigate(appOpenUrl)
  }

  return (
    <AppBase
      href={href}
      icon={icon}
      className={className}
      name={name}
      developerId={developerId}
    >
      <div className={classes.content}>
        <div className={classes.lists}>
          <dl className={classes.list}>
            <dt>Version</dt>
            <dd>{version}</dd>
          </dl>
          <dl className={classes.list}>
            <dt>Status</dt>
            <dd>{lang.marketplace.status[status]}</dd>
          </dl>
        </div>

        {appOpenUrl && <ButtonIconSquare label={lang.marketplace.form.testApp} onClick={onClick} />}
      </div>
    </AppBase>
  )
}

const useStyles = makeStyles(theme => ({
  list: {
    margin: '0 30px 0 0',
    color: theme.textColor,
    '& dt, & dd': {
      lineHeight: '26px',
    },
    '& dt': {
      textTransform: 'uppercase',
      fontSize: 12,
      color: theme.textLight,
    },
    '& dd': {
      margin: 0,
      fontSize: 17,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 80,
    flexGrow: '1',
  },
  lists: {
    display: 'flex',
    flexDirection: 'row',
  },
}))

OwnCard.propTypes = {
  name: PropTypes.string,
  icon: PropTypes.string,
  summary: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  status: PropTypes.oneOf([
    appConfig.status.STATUS_DEVELOPMENT,
    appConfig.status.STATUS_PENDING,
    appConfig.status.STATUS_REVIEW,
    appConfig.status.STATUS_REJECTED,
    appConfig.status.STATUS_APPROVED,
  ]),
}

OwnCard.defaultProps = {
  name: '',
  icon: '',
  summary: '',
  className: null,
  href: '#',
  status: appConfig.status.STATUS_DEVELOPMENT,
}

export default OwnCard
